import { Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import ReservationWidget from "@/components/ReservationWidget";
import Seo from "@/components/site/Seo";
import AvvisiBanner from "@/components/site/AvvisiBanner";
import ImageFrame from "@/components/site/ImageFrame";

export default function Prenota() {
  const { settings } = useSettings();
  return (
    <>
      <Seo
        title="Prenota un tavolo · Osteria Aterrana, Montoro (AV)"
        description="Prenota online un tavolo all'Osteria Aterrana, nel borgo storico di Aterrana a Montoro (AV). Scegli data, orario e numero di persone."
        path="/prenota"
      />
      <div className="pt-28 md:pt-32 bg-cream overflow-x-hidden">
        <AvvisiBanner />
        <div className="container-ed grid gap-12 lg:grid-cols-12 pb-24 md:pb-32 pt-10 md:pt-16">
          <div className="lg:col-span-4 min-w-0">
            <div className="flex items-center gap-4">
              <span className="rule" aria-hidden="true" />
              <p className="eyebrow text-sage">Prenota</p>
            </div>
            <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[3.6rem] leading-[1.05] text-wood">
              Un tavolo nel borgo
            </h1>
            <p className="mt-6 text-sm md:text-base text-foreground/70 leading-relaxed max-w-sm">
              La sala è piccola per scelta: prenotare è il modo migliore per essere sicuri di trovare
              posto. Riceverai subito il riepilogo per email e la conferma appena verifichiamo la sala.
            </p>
            <a
              href={`tel:${settings.phone_link || "+393311091971"}`}
              className="mt-8 inline-flex items-center gap-2 text-sm text-sage link-underline"
            >
              <Phone size={15} strokeWidth={1.5} /> Oppure chiamaci: {settings.phone || "331 10 91 971"}
            </a>
            <p
              className="mt-8 border-l-2 border-gold pl-4 text-sm text-foreground/70 leading-relaxed max-w-sm"
              data-testid="prenota-puntualita"
            >
              La nostra cucina è piccola e lavora pochi tavoli alla volta: i turni si susseguono a
              orari precisi e un ritardo di pochi minuti si somma alle prenotazioni successive,
              diventando attesa per tutti. Ti chiediamo la cortesia di rispettare l'orario prenotato,
              e una telefonata se qualcosa cambia: ci basta per riorganizzarci.
            </p>
            <div className="mt-12 hidden lg:block">
              <ImageFrame
                src={settings.prenota_image}
                label="INTERIOR PHOTO"
                alt="La sala dell'osteria: tavoli apparecchiati, travi in legno e muri in pietra"
                ratio="4 / 5"
              />
            </div>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 min-w-0 border border-wood/15 bg-beige/30 p-6 md:p-10">
            <ReservationWidget />
          </div>
        </div>
      </div>
    </>
  );
}
